<template v-if="showPopup.show">
  <v-row justify="center">
    <v-dialog :hide-overlay="true" max-width="600px" persistent value="true">
      <v-card>
        <v-card-title class="blue">
          <v-icon class="pa-1 mr-1" color="purple darken-3"
            >fas fa-file-medical</v-icon
          >
          <span class="headline"> Dokument erstellen</span>
        </v-card-title>
        <v-card-text class="pb-0 mb-0">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col>
                  <v-select
                    :items="items"
                    dense
                    label="Typ"
                    @change="typeChange"
                    v-model="data.Typ"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="LizenzTypen"
                    item-text="text"
                    item-value="value"
                    @change="LizenzTypeSelectionChange"
                    dense
                    label="Lizenz"
                    v-model="data.LizenzTyp"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    class="my-0 py-0"
                    label="Widerkehrende Rechnung"
                    v-model="data.CreateRecurringInvoice"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="my-0 py-0" cols="12">
                  <v-text-field
                    :rules="inputRules"
                    class="my-0 py-0"
                    label="Erste Zeile"
                    required
                    v-model="data.ErsteZeile"
                  ></v-text-field>
                </v-col>
                <v-col class="my-0 py-0" cols="12">
                  <v-text-field
                    class="my-0 py-0"
                    label="Zweite Zeile"
                    required
                    v-model="data.ZweiteZeile"
                  ></v-text-field>
                </v-col>
                <v-col class="my-0 py-0" cols="12">
                  <v-text-field
                    class="my-0 py-0"
                    label="Dritte Zeile"
                    required
                    v-model="data.DritteZeile"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="my-0 py-0" cols="6">
                  <v-text-field
                    :rules="decimalRules"
                    class="my-0 py-0"
                    label="Einzelpreis"
                    required
                    suffix="€"
                    v-model="data.Einzelpreis"
                  ></v-text-field>
                </v-col>
                <v-col class="my-0 py-0" cols="2">
                  <v-text-field
                    class="my-0 py-0"
                    label="Anzahl"
                    required
                    v-model="data.Anzahl"
                  />
                </v-col>
                <v-col class="my-0 py-0" cols="4">
                  <v-checkbox
                    class="my-0 py-0"
                    label="Lizenzen Anlegen"
                    v-model="data.CreateLicenses"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="my-0 py-0" cols="6">
                  <v-text-field
                    :rules="emptyRules"
                    class="my-0 py-0"
                    label="Rabatt"
                    required
                    v-model="data.Rabatt"
                  />
                </v-col>
                <v-col class="my-0 py-0" cols="6">
                  <v-text-field
                    :rules="ustRules"
                    class="my-0 py-0"
                    label="Ust"
                    required
                    suffix="%"
                    v-model="data.USt"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="my-0 py-0" cols="12">
                  <v-text-field
                    class="my-0 py-0"
                    label="Keys"
                    v-model="data.Keys"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-container class="elevation-1">
                <v-row>
                  <v-col class="my-0 py-0" cols="12">
                    <v-radio-group row v-model="data.Anrede">
                      <v-radio label="Frau" value="Frau"></v-radio>
                      <v-radio label="Herr" value="Herr"></v-radio>
                      <v-radio label="Neutral" value="Neutral"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="my-0 py-0" cols="6">
                    <v-text-field
                      class="my-0 py-0"
                      label="Email"
                      v-model="data.EmailAdresse"
                    ></v-text-field>
                  </v-col>
                  <v-col class="my-0 py-0" cols="6">
                    <v-text-field
                      class="my-0 py-0"
                      label="Name"
                      v-model="data.Name"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showPopup.show = false" color="blue darken-1" text
            >Schließen</v-btn
          >
          <v-btn :loading="loading" @click="submit" color="green darken-1" text
            >Speichern</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { HTTP } from "../http";
import { EventBus } from "../eventbus";

export default {
  props: {
    showPopup: Object,
    customer: Object,
  },
  data() {
    return {
      data: {
        CustomerID: this.customer.CustomerID,
        Typ: "Auftragsbestätigung + Rechnung",
        LizenzTyp: "excel-single",
        ErsteZeile: "Excel USt-ID Prüfer - Einzelplatz Lizenz",
        ZweiteZeile: "Jährliche Vorauszahlung",
        DritteZeile: null,
        Einzelpreis: 468,
        Anzahl: 1,
        Rabatt: "0",
        USt: 19.0,
        Keys: null,
        CreateRecurringInvoice: true,
        CreateEmail: true,
        CreateLicenses: false,
        Anrede: "Herr",
        EmailAdresse: this.customer.Email,
        Name: this.customer.AP,
      },

      emptyRules: [(v) => !!v || "Darf nicht leer sein"],

      decimalRules: [
        (v) => !!v || "Darf nicht leer sein",
        (v) => (v && /^\d+\.?\d*$/.test(v)) || "Muss eine Dezimalzahl sein.",
      ],

      ustRules: [
        (v) =>
          (0 <= parseInt(v) && parseInt(v) <= 100) ||
          "Ust muss zwischen 0 und 100 sein.",
      ],

      inputRules: [(v) => !!v || "Darf nicht leer sein"],
      loading: false,
      items: [
        "Auftragsbestätigung + Rechnung",
        "Renewal",
        "Angebot",
        "Auftragsbestätigung",
        "Rechnung",
        "Stornobeleg",
      ],

      LizenzTypen: [
        { text: "Excel - Single", value: "excel-single" },
        { text: "Excel - Enterprise", value: "excel-enterprise" },
        { text: "Online - Starter", value: "online-starter" },
        { text: "Online - Premium", value: "online-premium" },
        { text: "Online - Premium + API", value: "online-premiumapi" },
        { text: "Online - Enterprise", value: "online-enterprise" },
      ],
    };
  },
  methods: {
    typeChange() {
      if (this.data.Typ === "Auftragsbestätigung + Rechnung") {
        this.data.CreateRecurringInvoice = true;
      } else if (this.data.Typ === "Rechnung") {
        this.data.CreateRecurringInvoice = true;
      }
      else if (this.data.Typ === "Auftragsbestätigung") {
        this.data.CreateRecurringInvoice = true;
      }
      else  {
        this.data.CreateRecurringInvoice = false;
      }
    },
    LizenzTypeSelectionChange() {
      if (this.data.LizenzTyp == "excel-single") {
        this.data.Einzelpreis = 468;
        this.data.ErsteZeile = "Excel USt-ID Prüfer - Einzelplatz Lizenz";
      } else if (this.data.LizenzTyp == "excel-enterprise") {
        this.data.Einzelpreis = 2388;
        this.data.ErsteZeile = "Excel USt-ID Prüfer - Enterprise Lizenz";
      } else if (this.data.LizenzTyp == "online-starter") {
        this.data.Einzelpreis = 468;
        this.data.ErsteZeile = "Online Cloud USt-ID Prüfer - Starter";
      } else if (this.data.LizenzTyp == "online-premium") {
        this.data.Einzelpreis = 828;
        this.data.ErsteZeile = "Online Cloud USt-ID Prüfer - Premium";
      } else if (this.data.LizenzTyp == "online-premiumapi") {
        this.data.Einzelpreis = 2016;
        this.data.ErsteZeile = "Online Cloud USt-ID Prüfer - Premium + API";
      } else if (this.data.LizenzTyp == "online-enterprise") {
        this.data.Einzelpreis = 3588;
        this.data.ErsteZeile = "Online Cloud USt-ID Prüfer - Enterprise";
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        HTTP.post("api/Document", this.data)
          .then(() => {
            EventBus.$emit("reload");
            this.showPopup.show = false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
